import {CustomerSubscription} from '../types';
import {I18n} from '@aws-amplify/core';
import {
    PlatformPropertyCard,
    PlatformPropertyCardEntryInput,
} from '@flexinet/ui-components';
import {useAllowedItems} from '../../../hooks/useAllowedProperties.ts';
import {CreatedByProfileFormatter, UserProfile} from '../../../components/CreatedByProfileFormatter.tsx';
import {rbacActions} from '../../../config/rbac/actions.ts';

// ⚠️ Typed PlatformPropertyCardEntryInput[], never cast (FNP-1882). Cast, the array took
// `formatAs: 'Timestamp'` (the key is `formatter: 'timestamp'`) without a tsc error, the
// card ignored it, and Created and Last Updated rendered as raw ISO strings.
export const MetadataPropertyCard = ({record}: { record: CustomerSubscription }) => {

    const metadata: PlatformPropertyCardEntryInput[] = [
        {
            label: I18n.get('Created'),
            value: record.created,
            formatter: 'timestamp',
            span: 12,
        },
        {
            label: I18n.get('Created By'),
            value: <CreatedByProfileFormatter record={record as unknown as UserProfile}/>,
            rbac: rbacActions.UpdateSubscription,
            span: 12,
        },
        {
            label: I18n.get('Last Updated'),
            value: record.updated,
            formatter: 'timestamp',
            span: 12,
        }, {
            label: I18n.get('Updated By'),
            value: record.updatedByUsername ?? 'n/a',
            rbac: rbacActions.UpdateSubscription,
            span: 12,
        }];

    const {filterAllowed} = useAllowedItems();
    const metadataAllowedProperties = filterAllowed(metadata.filter(Boolean) as { rbac?: string }[]) as PlatformPropertyCardEntryInput[];

    return (<PlatformPropertyCard properties={metadataAllowedProperties}/>);
};
